/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Affix, Paper, Switch, Text, rem } from '@mantine/core';
import { useState, type ChangeEvent } from 'react';

import { worker } from '@fai/friendli-suite/mocks/browser';
import client from '@fai/friendli-suite/shared/apollo/base-link';
import { envIs } from '@fai/friendli-suite/shared/environments/conditionals';
import { TextVariants } from '@fai/ui/components/typography/variants';

const ignoredPathnames = [
  '.webp',
  '.jpeg',
  'src/pages',
  'src/views',
  'src/routes',
  'favicon',
  'typekit',
  // @fs is from libs
  '/@fs/',
  'chrome-extension://',
];

export function MSWAffix() {
  const [state, setState] = useState<boolean>(false);

  if (envIs.PRODUCTION || envIs.STAGING) return null;

  const onChangeSwitch = (e: ChangeEvent<HTMLInputElement>) => {
    setState(e.currentTarget.checked);

    if (e.currentTarget.checked) {
      worker.start({
        onUnhandledRequest(req, print) {
          if (ignoredPathnames.some((pathname) => req.url.includes(pathname))) {
            return;
          }

          print.warning();
        },
      });
    } else {
      worker.stop();
    }

    client.refetchQueries({ include: 'all' });
  };

  return (
    <Affix position={{ bottom: 20, left: 20 }}>
      <Paper
        bg={state ? 'red' : '#484848'}
        c="white"
        display="flex"
        px={rem(12)}
        py={rem(6)}
        shadow="xs"
        style={{ alignItems: 'center', gap: rem(8) }}
      >
        <Text span={true} variant={TextVariants.TitleSm}>
          {state ? 'MSW on!' : 'MSW off'}
        </Text>

        <Switch checked={state} color="#ffa162" size="xs" onChange={onChangeSwitch} />
      </Paper>
    </Affix>
  );
}
